import { useLayoutContext } from "@context/layout";
import { FC, useMemo } from "react";
import { getAvailableSources } from "./helpers";

const FestivalBannerPicture: FC = () => {
  const { fetstivalBanner } = useLayoutContext();
  const banner = fetstivalBanner?.is_active ? fetstivalBanner.banner : null;

  const sources = useMemo(() => {
    return banner ? getAvailableSources(banner) : [];
  }, [banner]);

  const fallbackSrc = sources[sources.length - 1]?.srcSet || "";
  const pictureSources = sources.slice(0, -1);

  if (!banner || !fallbackSrc) return null;

  const bannerUrl = banner.url.includes("subscription")
    ? "/subscription"
    : banner.url;

  return (
    <a
      href={bannerUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="absolute inset-0 z-0"
    >
      <picture className="block h-full w-full">
        {pictureSources.map((source) => (
          <source
            key={source.minWidth}
            media={`(min-width: ${source.minWidth}px)`}
            srcSet={source.srcSet}
            type={source.type}
          />
        ))}
        <img
          src={fallbackSrc}
          alt={banner.title || banner.slug}
          width={1280}
          height={56}
          decoding="sync"
          loading="eager"
          className="h-full w-full object-cover"
          {...{ fetchpriority: "high" }}
        />
      </picture>
    </a>
  );
};

export default FestivalBannerPicture;
